import { observer } from 'mobx-react-lite';
import { createContext, useContext } from 'react';
import { AuthStore } from './authStore';

const AuthContext = createContext<AuthStore | null>(null);

export const AuthProvider = observer(
  ({ children }: { children: React.ReactNode }) => {
    const store = new AuthStore();

    return (
      <AuthContext.Provider value={store}>{children}</AuthContext.Provider>
    );
  },
);

export const useAuth = () => {
  const store = useContext(AuthContext);
  if (!store) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return store;
};
